// src/hooks/useDateFilter.js

import { useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";

const useDateFilter = () => {
    const debounceRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    const handleDateChange = (key, value) => {
        const newParams = new URLSearchParams(location.search);
        newParams.set(key, value);

        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            navigate({ pathname: location.pathname, search: newParams.toString() });
        }, 400);
    };

    const removeDateFilter = () => {
        const newParams = new URLSearchParams(location.search);
        newParams.delete("filter_start");
        newParams.delete("filter_end");
        navigate({ pathname: location.pathname, search: newParams.toString() });
    };

    const startDate = new URLSearchParams(location.search).get("filter_start") || "";
    const endDate   = new URLSearchParams(location.search).get("filter_end")   || "";

    return { startDate, endDate, handleDateChange, removeDateFilter };
};

export default useDateFilter;